module.exports = __webpack_public_path__ + "img/helpdesk.e697262.jpg";